"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3779],{

/***/ 73779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MerchModuleWrapper_MerchModuleWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Layout/Layout.js
var Layout = __webpack_require__(88939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js + 6 modules
var ContentfulRichText = __webpack_require__(77626);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MerchModule/MerchModule.js + 3 modules
var MerchModule = __webpack_require__(48013);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/useGoogleAnalyticsTracking.ts


function useGoogleAnalyticsTracking(googleAnalyticsTracking) {
    (0,react.useEffect)(function() {
        if ((googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.action) && (googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.label)) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: googleAnalyticsTracking.category ? googleAnalyticsTracking.category : "promotion",
                action: googleAnalyticsTracking.action,
                label: googleAnalyticsTracking.label
            });
        }
    }, [
        googleAnalyticsTracking
    ]);
}

;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/MerchModuleContentTypeWrapper.tsx











function MerchModuleWrapper(param) {
    var content = param.content, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    var isMobile = (0,react.useContext)(BootstrapDataContext/* default */.Z).isMobile;
    var columnDisplayOptions = content.columnDisplayOptions, overline = content.overline, heading = content.heading, mediaDisplay = content.mediaDisplay, mediaPosition = content.mediaPosition, mediaDisplayRatio = content.mediaDisplayRatio, backgroundColor = content.backgroundColor, textAlign = content.textAlign, media = content.media, primaryCallToAction = content.primaryCallToAction, paragraph = content.paragraph, backgroundDisplay = content.backgroundDisplay, hideMediaOnMobile = content.hideMediaOnMobile, analyticsTracking = content.analyticsTracking, props = (0,_object_without_properties/* default */.Z)(content, [
        "columnDisplayOptions",
        "overline",
        "heading",
        "mediaDisplay",
        "mediaPosition",
        "mediaDisplayRatio",
        "backgroundColor",
        "textAlign",
        "media",
        "primaryCallToAction",
        "paragraph",
        "backgroundDisplay",
        "hideMediaOnMobile",
        "analyticsTracking"
    ]);
    useGoogleAnalyticsTracking(analyticsTracking);
    var moduleButtons = primaryCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        variation: "fill",
        href: primaryCallToAction.url,
        target: primaryCallToAction.openInNewTab ? "_blank" : undefined,
        rel: primaryCallToAction.openInNewTab ? "noopener" : undefined,
        "aria-label": primaryCallToAction.ariaLabel,
        onClick: function() {
            var ref;
            if ((ref = primaryCallToAction.analyticsTracking) === null || ref === void 0 ? void 0 : ref.action) {
                analytics/* default.fireEvent */.Z.fireEvent({
                    action: primaryCallToAction.analyticsTracking.action,
                    category: primaryCallToAction.analyticsTracking.category,
                    label: primaryCallToAction.analyticsTracking.label
                });
            }
        },
        children: primaryCallToAction.label
    }, primaryCallToAction.ariaLabel);
    var isBoxCheck = backgroundDisplay === "box";
    var imageDisplayMobile = hideMediaOnMobile === false;
    return isUsingNewLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModule/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isBox: isBoxCheck,
            columnVariation: [
                "100",
                null,
                columnDisplayOptions
            ],
            tagline: overline,
            headline: heading,
            mediaDisplay: mediaDisplay,
            mediaPosition: mediaPosition,
            imageAspectRatio: mediaDisplayRatio,
            imageDisplayMobile: imageDisplayMobile,
            backgroundColor: backgroundColor,
            isMobile: isMobile
        }, props), {
            textAlign: textAlign,
            minImageHeight: "400px",
            imageUrl: (media === null || media === void 0 ? void 0 : media.file.url) ? "".concat(media.file.url, "?fm=webp") : undefined,
            imageAlt: media === null || media === void 0 ? void 0 : media.description,
            callToAction: primaryCallToAction,
            headingTextStyle: "heading1",
            taglineTextStyle: "overline",
            bodyLineHeight: "25px",
            headingMB: "0px",
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                color: "text.dark",
                textStyle: "article",
                fontSize: 3,
                body: paragraph
            }),
            actions: moduleButtons
        }))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        p: isMobile ? undefined : 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModule/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isBox: isBoxCheck,
            columnVariation: [
                "100",
                null,
                columnDisplayOptions
            ],
            tagline: overline,
            headline: heading,
            mediaDisplay: mediaDisplay,
            mediaPosition: mediaPosition,
            imageAspectRatio: mediaDisplayRatio,
            imageDisplayMobile: imageDisplayMobile,
            backgroundColor: backgroundColor,
            isMobile: isMobile
        }, props), {
            textAlign: textAlign,
            minImageHeight: "400px",
            imageUrl: (media === null || media === void 0 ? void 0 : media.file.url) ? "".concat(media.file.url, "?fm=webp") : undefined,
            imageAlt: media === null || media === void 0 ? void 0 : media.description,
            callToAction: primaryCallToAction,
            headingTextStyle: "heading1",
            taglineTextStyle: "overline",
            bodyLineHeight: "25px",
            headingMB: "0px",
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                color: "text.dark",
                textStyle: "article",
                fontSize: 3,
                body: paragraph
            }),
            actions: moduleButtons
        }))
    });
}
/* harmony default export */ var MerchModuleContentTypeWrapper = (MerchModuleWrapper);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/LayoutComponentWrapper/index.tsx
var LayoutComponentWrapper = __webpack_require__(47418);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/graphics/AppleStoreSvg.tsx


function AppleStoreSvg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "149",
        height: "44",
        viewBox: "0 0 149 44",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "none",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A6A6A6",
                    d: "M143.699 44H5.219C2.342 44 0 41.66 0 38.794V5.199C0 2.332 2.342 0 5.22 0h138.479C146.575 0 149 2.332 149 5.199v33.595c0 2.865-2.425 5.206-5.301 5.206z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#000",
                    d: "M147.932 38.795a4.22 4.22 0 0 1-4.232 4.213H5.22c-2.34 0-4.238-1.886-4.238-4.213V5.197C.982 2.871 2.881.98 5.22.98H143.7a4.225 4.225 0 0 1 4.232 4.218v33.598z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    fill: "#FFF",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33.252 21.762c-.032-3.545 2.913-5.27 3.048-5.35-1.668-2.423-4.253-2.754-5.161-2.78-2.171-.229-4.277 1.294-5.383 1.294-1.128 0-2.831-1.273-4.666-1.235-2.362.036-4.572 1.399-5.784 3.515-2.5 4.316-.636 10.657 1.76 14.145 1.2 1.708 2.6 3.616 4.433 3.549 1.794-.074 2.464-1.14 4.628-1.14 2.144 0 2.773 1.14 4.643 1.097 1.925-.031 3.137-1.716 4.294-3.44 1.385-1.958 1.941-3.886 1.963-3.985-.045-.016-3.738-1.42-3.775-5.67zM29.72 11.337c.965-1.203 1.625-2.838 1.442-4.498-1.396.061-3.142.962-4.148 2.138-.89 1.036-1.684 2.735-1.479 4.332 1.569.117 3.179-.789 4.186-1.972z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    fill: "#FFF",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M59.208 34.654h-2.506l-1.373-4.3h-4.773l-1.308 4.3h-2.44l4.728-14.638h2.92l4.752 14.638zm-4.293-6.104l-1.242-3.822c-.131-.39-.377-1.31-.74-2.758h-.045c-.144.623-.377 1.543-.697 2.758l-1.22 3.823h3.944zM71.368 29.247c0 1.795-.487 3.214-1.46 4.256-.872.927-1.955 1.39-3.248 1.39-1.395 0-2.397-.5-3.007-1.498h-.044v5.56h-2.353V27.574c0-1.129-.03-2.287-.088-3.475h2.07l.131 1.673h.044c.785-1.26 1.976-1.89 3.574-1.89 1.25 0 2.292.492 3.127 1.476.836.986 1.254 2.282 1.254 3.889zm-2.398.086c0-1.028-.231-1.875-.697-2.541-.509-.696-1.192-1.043-2.049-1.043-.58 0-1.108.193-1.579.575a2.667 2.667 0 0 0-.926 1.51 3.06 3.06 0 0 0-.11.715v1.76c0 .768.237 1.416.71 1.945.472.53 1.085.793 1.84.793.887 0 1.576-.34 2.07-1.02.494-.681.741-1.579.741-2.694zM83.55 29.247c0 1.795-.487 3.214-1.462 4.256-.87.927-1.954 1.39-3.246 1.39-1.395 0-2.397-.5-3.007-1.498h-.044v5.56h-2.353V27.574c0-1.129-.03-2.287-.087-3.475h2.07l.13 1.673h.045c.784-1.26 1.975-1.89 3.574-1.89 1.248 0 2.291.492 3.128 1.476.833.986 1.251 2.282 1.251 3.889zm-2.398.086c0-1.028-.233-1.875-.699-2.541-.508-.696-1.19-1.043-2.047-1.043-.582 0-1.108.193-1.58.575-.473.385-.78.888-.925 1.51-.072.29-.11.528-.11.715v1.76c0 .768.237 1.416.707 1.945.472.528 1.086.793 1.843.793.886 0 1.576-.34 2.07-1.02.494-.681.741-1.579.741-2.694zM97.169 30.55c0 1.244-.434 2.257-1.305 3.04-.957.854-2.289 1.281-4 1.281-1.581 0-2.848-.304-3.807-.912l.545-1.955a6.467 6.467 0 0 0 3.402.935c.886 0 1.576-.2 2.071-.598.494-.398.74-.933.74-1.6 0-.593-.203-1.094-.61-1.5-.406-.406-1.082-.783-2.027-1.132-2.572-.956-3.856-2.356-3.856-4.197 0-1.204.45-2.19 1.352-2.958.898-.769 2.097-1.153 3.596-1.153 1.336 0 2.446.232 3.333.695l-.589 1.912c-.827-.449-1.763-.673-2.81-.673-.828 0-1.475.203-1.939.608a1.735 1.735 0 0 0-.588 1.326c0 .578.224 1.057.674 1.433.392.348 1.104.724 2.137 1.13 1.264.507 2.192 1.1 2.79 1.78.594.677.891 1.525.891 2.537zM104.949 25.859h-2.594v5.125c0 1.303.457 1.954 1.373 1.954.42 0 .77-.036 1.045-.109l.066 1.781c-.464.173-1.074.26-1.83.26-.93 0-1.656-.283-2.18-.847-.522-.565-.785-1.514-.785-2.846v-5.32H98.5v-1.76h1.545v-1.933l2.311-.695v2.628h2.594v1.762zM116.652 29.29c0 1.622-.466 2.954-1.396 3.996-.974 1.072-2.268 1.607-3.88 1.607-1.554 0-2.791-.514-3.714-1.541s-1.384-2.324-1.384-3.887c0-1.636.474-2.976 1.427-4.018.95-1.042 2.233-1.564 3.845-1.564 1.554 0 2.805.514 3.748 1.542.903.998 1.354 2.286 1.354 3.865zm-2.442.076c0-.974-.208-1.809-.631-2.505-.494-.843-1.199-1.263-2.113-1.263-.946 0-1.664.421-2.157 1.263-.423.697-.632 1.545-.632 2.549 0 .973.209 1.808.632 2.503.508.843 1.22 1.263 2.136 1.263.899 0 1.604-.429 2.113-1.285.434-.71.652-1.553.652-2.525zM124.3 26.161a4.1 4.1 0 0 0-.741-.065c-.828 0-1.468.312-1.919.935-.392.55-.588 1.246-.588 2.085v5.538H118.7l.022-7.231c0-1.217-.03-2.324-.088-3.323h2.05l.085 2.02h.066c.248-.695.64-1.253 1.176-1.672a2.852 2.852 0 0 1 1.7-.566c.218 0 .415.016.59.043v2.236zM134.824 28.877c0 .42-.028.775-.086 1.064h-7.06c.028 1.043.37 1.84 1.025 2.39.595.492 1.364.738 2.309.738 1.045 0 1.999-.166 2.856-.5l.369 1.629c-1.002.435-2.185.652-3.55.652-1.643 0-2.932-.482-3.87-1.444-.936-.963-1.405-2.255-1.405-3.876 0-1.592.436-2.918 1.309-3.975.914-1.128 2.149-1.693 3.703-1.693 1.526 0 2.682.565 3.466 1.693.622.897.934 2.006.934 3.322zm-2.244-.608c.016-.695-.138-1.296-.457-1.803-.407-.652-1.033-.978-1.875-.978-.77 0-1.395.318-1.873.956-.392.507-.625 1.115-.696 1.824h4.901z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    fill: "#FFF",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M54.137 11.01c0 1.295-.39 2.27-1.168 2.924-.72.604-1.745.906-3.072.906-.657 0-1.22-.029-1.692-.086V7.68c.615-.099 1.277-.15 1.993-.15 1.263 0 2.216.274 2.858.822.72.62 1.08 1.505 1.08 2.658zm-1.22.032c0-.84-.223-1.483-.669-1.932-.446-.448-1.097-.672-1.954-.672-.365 0-.675.024-.932.075v5.378c.142.022.403.032.781.032.886 0 1.569-.246 2.05-.736.481-.49.724-1.206.724-2.145zM60.603 12.14c0 .798-.228 1.452-.685 1.964-.48.527-1.114.79-1.906.79-.764 0-1.372-.252-1.826-.758-.452-.505-.679-1.142-.679-1.91 0-.803.233-1.461.701-1.973.468-.511 1.097-.768 1.89-.768.764 0 1.377.252 1.842.757.441.49.663 1.124.663 1.899zm-1.2.038c0-.478-.103-.889-.31-1.23-.242-.414-.588-.621-1.037-.621-.465 0-.818.207-1.06.62-.208.342-.31.76-.31 1.252 0 .478.103.889.31 1.23.25.414.599.621 1.049.621.441 0 .788-.21 1.037-.631.214-.349.322-.762.322-1.24zM69.274 9.59l-1.628 5.186h-1.06l-.674-2.251c-.171-.563-.31-1.121-.418-1.676h-.021c-.1.57-.24 1.128-.418 1.676l-.717 2.251h-1.071l-1.531-5.185h1.188l.589 2.465c.142.583.259 1.139.353 1.664h.02c.087-.433.23-.985.43-1.653l.739-2.475h.942l.708 2.422c.17.59.31 1.16.417 1.707h.032c.078-.533.196-1.102.353-1.707l.631-2.422h1.136v-.001zM75.27 14.776h-1.156v-2.97c0-.915-.35-1.372-1.049-1.372-.343 0-.62.125-.835.377a1.336 1.336 0 0 0-.321.889v3.075h-1.157v-3.702c0-.456-.015-.95-.042-1.484h1.016l.054.81h.032c.135-.251.336-.46.6-.625a1.96 1.96 0 0 1 1.048-.292c.486 0 .89.156 1.211.47.4.384.6.957.6 1.718v3.106zM78.46 14.776h-1.155V7.212h1.155zM85.27 12.14c0 .798-.229 1.452-.685 1.964-.48.527-1.115.79-1.907.79-.764 0-1.373-.252-1.825-.758-.453-.505-.679-1.142-.679-1.91 0-.803.233-1.461.701-1.973.468-.511 1.097-.768 1.888-.768.765 0 1.378.252 1.844.757.441.49.663 1.124.663 1.899zm-1.2.038c0-.478-.105-.889-.311-1.23-.242-.414-.588-.621-1.036-.621-.466 0-.82.207-1.061.62-.208.342-.31.76-.31 1.252 0 .478.104.889.31 1.23.25.414.6.621 1.05.621.441 0 .786-.21 1.036-.631.215-.349.321-.762.321-1.24zM90.868 14.776h-1.039l-.086-.597h-.032c-.355.476-.862.715-1.52.715-.49 0-.888-.157-1.187-.47a1.47 1.47 0 0 1-.407-1.056c0-.633.264-1.116.798-1.45.532-.335 1.28-.499 2.243-.491v-.097c0-.683-.36-1.024-1.08-1.024-.513 0-.966.129-1.357.384l-.235-.757c.484-.298 1.08-.448 1.785-.448 1.36 0 2.042.715 2.042 2.145v1.91c0 .518.025.93.075 1.236zm-1.2-1.782v-.8c-1.277-.021-1.915.327-1.915 1.046 0 .27.073.473.222.608a.81.81 0 0 0 .565.202c.254 0 .491-.08.708-.24a.982.982 0 0 0 .42-.816zM97.44 14.776h-1.026l-.054-.832h-.032c-.328.633-.886.95-1.671.95-.627 0-1.149-.245-1.563-.736-.414-.49-.62-1.127-.62-1.91 0-.839.224-1.519.674-2.038.436-.484.97-.726 1.606-.726.699 0 1.188.235 1.466.704h.022V7.212H97.4v6.167c0 .505.013.97.04 1.397zm-1.198-2.187v-.864a1.312 1.312 0 0 0-.45-1.062 1.14 1.14 0 0 0-.774-.282c-.432 0-.77.17-1.018.512-.246.342-.37.78-.37 1.313 0 .512.117.928.355 1.248.25.341.588.512 1.01.512.38 0 .684-.142.915-.427.223-.263.332-.58.332-.95zM107.333 12.14c0 .798-.228 1.452-.685 1.964-.48.527-1.113.79-1.907.79-.762 0-1.37-.252-1.825-.758-.453-.505-.679-1.142-.679-1.91 0-.803.233-1.461.701-1.973.468-.511 1.097-.768 1.89-.768.763 0 1.378.252 1.842.757.441.49.663 1.124.663 1.899zm-1.199.038c0-.478-.103-.889-.31-1.23-.244-.414-.588-.621-1.038-.621-.464 0-.817.207-1.061.62-.208.342-.31.76-.31 1.252 0 .478.104.889.31 1.23.25.414.6.621 1.05.621.441 0 .789-.21 1.038-.631.213-.349.321-.762.321-1.24zM113.552 14.776h-1.155v-2.97c0-.915-.349-1.372-1.05-1.372-.343 0-.62.125-.834.377a1.33 1.33 0 0 0-.321.889v3.075h-1.158v-3.702c0-.456-.013-.95-.041-1.484h1.015l.054.81h.032c.136-.251.337-.46.6-.625a1.964 1.964 0 0 1 1.05-.292c.484 0 .888.156 1.209.47.4.384.6.957.6 1.718v3.106zM121.337 10.454h-1.274v2.52c0 .64.226.96.674.96.208 0 .38-.018.516-.054l.03.874c-.229.086-.529.129-.899.129-.457 0-.812-.139-1.07-.416-.257-.277-.386-.743-.386-1.398v-2.615h-.76v-.863h.76v-.95l1.134-.342v1.29h1.274v.865zM127.46 14.776h-1.158v-2.948c0-.93-.348-1.395-1.047-1.395-.536 0-.903.27-1.104.809a1.444 1.444 0 0 0-.054.415v3.118h-1.155V7.212h1.155v3.125h.022c.364-.569.886-.853 1.563-.853.48 0 .875.156 1.19.47.392.39.588.971.588 1.739v3.083zM133.777 11.938c0 .207-.016.38-.043.523h-3.47c.016.512.182.903.503 1.173.293.242.672.363 1.136.363.513 0 .98-.08 1.402-.245l.181.801c-.493.213-1.074.32-1.746.32-.805 0-1.44-.236-1.9-.71-.46-.472-.689-1.107-.689-1.904 0-.782.213-1.433.642-1.952.448-.554 1.054-.832 1.82-.832.748 0 1.316.278 1.7.832.31.44.464.984.464 1.631zm-1.104-.298a1.548 1.548 0 0 0-.224-.885c-.201-.32-.507-.481-.92-.481a1.1 1.1 0 0 0-.921.47c-.192.25-.306.547-.343.896h2.408z"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var graphics_AppleStoreSvg = (AppleStoreSvg);

;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/graphics/PlayStoreSvg.tsx


function PlayStoreSvg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "149",
        height: "44",
        viewBox: "0 0 149 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "a",
                        width: "149",
                        height: "43.92",
                        rx: "5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "c",
                        x1: "50%",
                        x2: "50%",
                        y1: "0%",
                        y2: "38.913%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FBDA09"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FFBC00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "b",
                        d: "M11.162 3.567c.86-1.51 2.257-1.505 3.115 0l12.245 21.485c.86 1.509.137 2.732-1.586 2.732H.503c-1.735 0-2.443-1.228-1.585-2.732L11.162 3.567z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "d",
                        x1: "0%",
                        x2: "69.306%",
                        y1: "58.476%",
                        y2: "39.083%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#01E2FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#01C4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "f",
                        x1: "20.281%",
                        x2: "83.82%",
                        y1: "20.102%",
                        y2: "83.621%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#28D781"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#02F076"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "g",
                        x1: "74.488%",
                        x2: "10.108%",
                        y1: "17.43%",
                        y2: "91.184%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#F2414E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#E02554"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                fill: "#000",
                                xlinkHref: "#a"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "148",
                                height: "42.92",
                                x: ".5",
                                y: ".5",
                                stroke: "#A6A6A6",
                                rx: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "148.5",
                                height: "43.42",
                                x: ".25",
                                y: ".25",
                                stroke: "#8F8F8F",
                                strokeWidth: ".5",
                                rx: "5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#FFF",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M78.959 14.6a3.604 3.604 0 0 1-3.607-3.6c0-1.988 1.615-3.6 3.607-3.6a3.604 3.604 0 0 1 3.607 3.6c0 1.988-1.615 3.6-3.607 3.6zm0-1.1a2.503 2.503 0 0 0 2.505-2.5c0-1.38-1.122-2.5-2.505-2.5a2.503 2.503 0 0 0-2.505 2.5c0 1.38 1.121 2.5 2.505 2.5zM54.51 11.4v2.2h2.906v.8h-4.008V7.7h4.008v.8H54.51v2.1h2.605v.8H54.51zM61.323 8.5v5.9h-1.102V8.5h-1.703v-.8h4.509v.8h-1.704zM71.143 8.5v5.9h-1.102V8.5h-1.703v-.8h4.509v.8h-1.704zM66.233 7.7h1.102v6.7h-1.102zM84.12 7.7h-.652v6.7h1.102V9.17l3.207 5.23h1.102V7.7h-1.102v4.902L84.77 7.7h-.652zM49.278 10.717h3.017l-.03.953h-2.987z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M51.702 8.474c-.588-.618-1.447-.974-2.47-.974a3.535 3.535 0 0 0-3.54 3.53 3.537 3.537 0 0 0 3.54 3.53c1.989.017 3.647-1.38 3.316-3.808v-.035h-.882c.007.101.01.206.007.313.002 1.733-1 2.547-2.41 2.547a2.55 2.55 0 0 1-2.555-2.547 2.55 2.55 0 0 1 2.555-2.547c.705 0 1.317.24 1.748.68l.69-.689z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#FFF",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M108.218 19.7h5.68s3.27.555 3.27 4.303c0 3.748-3.27 4.303-3.27 4.303h-5.68V19.7zm1.102 2.082V26.4h3.856s1.755 0 1.755-2.31c0-2.308-1.755-2.308-1.755-2.308h-3.856z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M107.717 19.7h2.004v14h-2.004zM118.338 19.7h2.004v14h-2.004zM127.77 32.699c-.552.455-1.434.882-2.828.97-3.193.198-3.195-2.71-3.195-2.906 0-.196-.157-2.567 2.383-2.944 1.798-.267 3.058.178 3.64.46v-.411c-.143-.545-.586-1.546-1.914-1.546-1.825 0-2.228.984-2.228.984l-1.669-.984s.934-1.922 3.737-1.922c3.485 0 4.078 2.399 4.078 3.207V33.696h-2.004v-.997zm-.143-2.999s-3.86-1.038-3.995 1.126c-.134 2.165 3.704 1.126 4.047-.409 0-.488-.052-.717-.052-.717zM133.535 33.169l-1.87 4.431h2.004l5.422-12.852h-2.004l-2.55 6.046-2.571-6.094h-2.004l3.573 8.469zM103.23 27.973l-6.338 2.614s.41 1.446 2.315 1.455c1.492.008 2.335-1.32 2.335-1.32l1.608 1.087s-1.298 2.095-3.955 2.095c-3.266 0-4.705-2.85-4.705-4.701 0-1.783 1.142-4.803 4.502-4.803s4.238 3.573 4.238 3.573zm-2.411-.741s-.798-1.21-2.02-.988c-2.588.473-2.262 2.732-2.262 2.732l4.282-1.744zM91.484 19.7h2.12v13.971h-2.12zM88.091 24.704l1.96.017v8.815c0 2.252-1.343 4.63-4.507 4.63-3.163 0-4.184-2.798-4.184-2.798l1.8-.755s.549 1.724 2.478 1.724c2.197 0 2.454-1.995 2.454-2.678v-.957s-.76 1.188-2.649 1.188c-2.047 0-4.48-1.75-4.48-4.735 0-2.984 2.29-4.691 4.504-4.754 1.772-.05 2.624 1.174 2.624 1.174v-.871zm-2.48 7.394c1.429 0 2.587-1.306 2.587-2.918s-1.158-2.918-2.588-2.918c-1.429 0-2.587 1.306-2.587 2.918s1.158 2.918 2.587 2.918zM75.312 33.9c-2.634 0-4.77-2.127-4.77-4.75s2.136-4.75 4.77-4.75c2.635 0 4.77 2.127 4.77 4.75s-2.135 4.75-4.77 4.75zm-.03-1.863c1.48 0 2.68-1.292 2.68-2.887s-1.2-2.887-2.68-2.887c-1.482 0-2.682 1.292-2.682 2.887s1.2 2.887 2.681 2.887zM64.992 33.9c-2.635 0-4.77-2.127-4.77-4.75s2.135-4.75 4.77-4.75c2.634 0 4.77 2.127 4.77 4.75s-2.136 4.75-4.77 4.75zm-.032-1.863c1.481 0 2.682-1.292 2.682-2.887s-1.2-2.887-2.682-2.887c-1.48 0-2.681 1.292-2.681 2.887s1.2 2.887 2.681 2.887z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M52.674 25.906h6.298l-.062 1.987h-6.236z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M57.733 21.23c-1.226-1.288-3.02-2.03-5.153-2.03-4.08 0-7.389 3.294-7.389 7.358 0 4.063 3.308 7.352 7.39 7.358 4.149.037 7.61-2.877 6.917-7.936v-.074h-1.84c.015.211.02.429.015.652.005 3.614-2.086 5.309-5.03 5.309-2.945 0-5.332-2.377-5.332-5.31 0-2.931 2.387-5.308 5.332-5.308 1.473 0 2.75.502 3.648 1.417l1.442-1.435z"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(10.922 6.8)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                id: "e",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    xlinkHref: "#b"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                fill: "url(#c)",
                                transform: "rotate(90 12.72 15.11)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#d)",
                                d: "M0 .99l14.007 13.894L-.181 29.326z",
                                mask: "url(#e)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#f)",
                                d: "M-2.88-1.87l16.885 16.758 5.02-4.78z",
                                mask: "url(#e)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#g)",
                                d: "M14.008 14.885l7.685 7.73-22.96 7.732z",
                                mask: "url(#e)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var graphics_PlayStoreSvg = (PlayStoreSvg);

;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/ToutContentTypeWrapper.tsx
















var Graphics = {
    AppleStore: graphics_AppleStoreSvg,
    PlayStore: graphics_PlayStoreSvg
};
function renderGraphic(svgName) {
    var SVG = Graphics[svgName];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG, {});
}
var ANALYTICS_CATEGORIES = {
    "/flights": constants_analytics/* ANALYTICS_CATEGORY_FLIGHTS */.y1,
    "/hotels": constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
    "/vacationpackages": constants_analytics/* ANALYTICS_CATEGORY_PACKAGES */.Bd,
    "/": constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG
};
function ToutWrapper(param) {
    var content = param.content, _credCardModWrapDefaultDisplay = param.credCardModWrapDefaultDisplay, credCardModWrapDefaultDisplay = _credCardModWrapDefaultDisplay === void 0 ? false : _credCardModWrapDefaultDisplay, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var pathname = router === null || router === void 0 ? void 0 : router.pathname;
    var googleAnalyticsCategory = ANALYTICS_CATEGORIES[pathname];
    var googleAnalyticsTracking = content.googleAnalyticsTracking, callsToAction = content.callsToAction;
    useGoogleAnalyticsTracking(googleAnalyticsTracking);
    var moduleButtons = callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: callsToAction.map(function(cta) {
            var linkVariation = cta.svgName ? "link" : "fill";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                mr: 2,
                variation: linkVariation,
                href: cta.url,
                target: cta.openInNewTab ? "_blank" : undefined,
                rel: cta.openInNewTab ? "noopener" : undefined,
                "aria-label": cta.ariaLabel,
                onClick: function() {
                    var ref;
                    if ((ref = cta.googleAnalyticsTracking) === null || ref === void 0 ? void 0 : ref.action) {
                        analytics/* default.fireEvent */.Z.fireEvent({
                            action: cta.googleAnalyticsTracking.action,
                            category: cta.googleAnalyticsTracking.category || googleAnalyticsCategory,
                            label: cta.googleAnalyticsTracking.label
                        });
                    }
                },
                children: cta.svgName ? renderGraphic(cta.svgName) : cta.label
            }, cta.ariaLabel);
        })
    });
    var isMobile = (0,react.useContext)(BootstrapDataContext/* default */.Z).isMobile;
    var displayOption = content.displayOption, image = content.image, body = content.body, props = (0,_object_without_properties/* default */.Z)(content, [
        "displayOption",
        "image",
        "body"
    ]);
    var currentCustomCreditCardDisplayProps = credCardModWrapDefaultDisplay ? {
        boxProps: {
            py: 4,
            px: 4,
            mb: 4
        },
        textAlign: "left"
    } : {
        boxProps: {
            mx: isMobile ? 0 : 4,
            mt: isMobile ? "40px" : 0,
            mb: 4,
            p: 4
        }
    };
    var newCustomCreditCardDisplayProps = credCardModWrapDefaultDisplay ? {
        boxProps: {
            p: 4
        },
        textAlign: "left"
    } : {
        boxProps: {
            p: 4
        }
    };
    var customCreditCardDisplayProps = isUsingNewLayout ? newCustomCreditCardDisplayProps : currentCustomCreditCardDisplayProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponentWrapper/* default */.Z, {
        isUsingNewLayout: isUsingNewLayout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModule/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, customCreditCardDisplayProps), {
            isBox: true,
            minImageHeight: "400px",
            mediaDisplay: displayOption,
            imageUrl: (image === null || image === void 0 ? void 0 : (ref = image.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) ? "".concat(image.asset.file.url, "?h=600&q=70&fm=webp") : undefined,
            imageAlt: image === null || image === void 0 ? void 0 : image.altText,
            callToAction: image === null || image === void 0 ? void 0 : image.callToAction,
            headingTextStyle: "heading2",
            taglineTextStyle: "overline",
            bodyLineHeight: "25px",
            isMobile: isMobile,
            headingMB: "0px",
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                color: "text.dark",
                textStyle: "article",
                fontSize: 3,
                body: body
            }),
            actions: moduleButtons
        }))
    });
}
/* harmony default export */ var ToutContentTypeWrapper = (ToutWrapper);

;// CONCATENATED MODULE: ./src/components/MerchModuleWrapper/index.tsx




function isToutType(promo) {
    return promo.contentTypeId === "tout";
}
function MerchModuleWrapper_MerchModuleWrapper(param) {
    var content = param.content, _credCardModWrapDefaultDisplay = param.credCardModWrapDefaultDisplay, credCardModWrapDefaultDisplay = _credCardModWrapDefaultDisplay === void 0 ? false : _credCardModWrapDefaultDisplay, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    if (isToutType(content)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToutContentTypeWrapper, {
            content: content,
            credCardModWrapDefaultDisplay: credCardModWrapDefaultDisplay,
            isUsingNewLayout: isUsingNewLayout
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModuleContentTypeWrapper, {
        content: content
    });
}


/***/ })

}]);